export const MENUETTPORTALVA = "Vårdgivaransvarig";
export const MENUETTPORTALMA = "Mottagningsansvarig";
export const MENUETTPORTALKOMMUN_BOENDESAMORDNARE= "Boendesamordnare";
export const MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR = "Kommunal administratör";
export const MENUETTPORTALKOMMUN_KOMUNALKONTAKTPERSON = "Kommunal kontaktperson";
export const MENUETTPORTALKOMMUN_PRIVATANSVARIG = "Privat ansvarig";
export const MENUETTPORTALKOMMUN_PRIVATANSVARIG_ROLEID = "85";
